import {Component, Input} from '@angular/core';
import {ServicesService} from '../../../../domain/services/services.service';
import {ServiceConfiguration} from '../../../../domain/services/service-configuration';
import {Vaps} from "../../../../domain/vaps/vaps";

@Component({
  selector: 'services-section',
  templateUrl: './services-section.component.html',
  providers: [ServicesService]
})
export class ServicesSectionComponent {
  @Input()
  vaps: Vaps[] = [];

  constructor(private services: ServicesService) {
  }

  get show(): boolean {
    return this.serviceConfiguration.package != null || this.serviceConfiguration.services.length > 0;
  }

  get serviceConfiguration(): ServiceConfiguration {
    return this.services.serviceConfiguration;
  }
}
